var map = {
	"./add-photo.svg": "9daa",
	"./approving.svg": "2a29",
	"./arrow.svg": "21e2",
	"./attach.svg": "0328",
	"./back-arrow.svg": "85f2",
	"./camera.svg": "24e5",
	"./cancelled.svg": "0e73",
	"./change-gray.svg": "4447",
	"./change.svg": "9440",
	"./chat.svg": "9b69",
	"./check-black.svg": "4793",
	"./check-grey.svg": "7d3a",
	"./check.svg": "7bae",
	"./claim.svg": "c533",
	"./close.svg": "8b1b",
	"./download.svg": "f28e",
	"./expand.svg": "8336",
	"./external-link.svg": "b64a",
	"./goods-accepted.svg": "d11b",
	"./home.svg": "ac9d",
	"./information.svg": "e923",
	"./logout.svg": "69e3",
	"./print.svg": "671e",
	"./return-gray.svg": "ebab",
	"./return.svg": "60e9",
	"./send.svg": "5b6e",
	"./user-default.svg": "e570"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";